
import { ReactNode } from "react";
import { Card, CardContent } from "@/components/ui/card";

interface StandardCardProps {
  children: ReactNode;
  className?: string;
  padding?: "sm" | "md" | "lg";
  hover?: boolean;
}

export const StandardCard = ({ 
  children, 
  className = "", 
  padding = "md", 
  hover = false 
}: StandardCardProps) => {
  const paddingClasses = {
    sm: "p-4",
    md: "p-6",
    lg: "p-8"
  };

  const hoverClasses = hover ? "hover:shadow-lg transition-all duration-300" : "";

  return (
    <Card className={`bg-white border border-gray-200 ${hoverClasses} ${className}`}>
      <CardContent className={paddingClasses[padding]}>
        {children}
      </CardContent>
    </Card>
  );
};
